import { useProfile } from '../zustand/store'

export const useUserRole = () => {
  const { role } = useProfile()

  const hasRole = (name: string) => role.includes(name.toLowerCase())

  return {
    hasRole,
    isDoctor: hasRole('doctor'),
    isNurse: hasRole('nurse'),
    isPharmacist: hasRole('pharmacist'),
    isReceptionist: hasRole('receptionist'),
    isAdmin: hasRole('admin'),
    isSuperAdmin: hasRole('super_admin'),
    role
  }
}
